import { render, staticRenderFns } from "./resumo-qualificacao-tecnica.vue?vue&type=template&id=1339ba22&scoped=true"
import script from "./resumo-qualificacao-tecnica.vue?vue&type=script&lang=js"
export * from "./resumo-qualificacao-tecnica.vue?vue&type=script&lang=js"
import style0 from "./resumo-qualificacao-tecnica.vue?vue&type=style&index=0&id=1339ba22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1339ba22",
  null
  
)

export default component.exports